import React, { useEffect, useState } from "react";
import { getFormattedTimeByHoursFormat, padWithZero } from "../../utils/utilDates";
import DropdownField from "../input-fields/DropdownField";

const TimeSlot = ({
  timeSlot,
  setFromSlot,
  setToSlot,
  canDelete,
  canAdd,
  onAddNewTimeSlot,
  onDeleteTimeSlot,
  isValid,
  interval = 30,
}) => {
  const [fromOptions, setFromOptions] = useState([]);
  const [toOptions, setToOptions] = useState([]);

  const generateTimeOptions = (startTime = "") => {
    const options = [];
    for (let i = 0; i <= 24; i++) {
      if (!startTime && i === 24) {
        continue;
      }
      const hour = i < 10 ? `${i}` : i;
      for (let j = 0; j < 60; j += interval) {
        const minute = padWithZero(j);
        const option = getFormattedTimeByHoursFormat(hour, minute);
        options.push({ option: option, value: `${hour}:${minute}` });

        if (i === 24) {
          break;
        }
      }
    }

    if (startTime) {
      const startIndex = options.findIndex((option) => option.value === startTime);
      return options.slice(startIndex + 1);
    }

    return options;
  };

  useEffect(() => {
    const fromOptions = generateTimeOptions();
    setFromOptions(fromOptions);

    const toOptions = generateTimeOptions(timeSlot.from);
    setToOptions(toOptions);

    if (timeSlot.to && toOptions.findIndex((option) => option.value === timeSlot.to) === -1) {
      setToSlot("");
    }
  }, [timeSlot.from, timeSlot.to]);

  return (
    <div className="w-full flex items-center gap-4">
      <DropdownField
        title={"From"}
        defaultOption={{ value: null, option: "From" }}
        options={fromOptions}
        selectedOption={timeSlot.from}
        onChange={(value) => setFromSlot(value)}
        errorMessage={!isValid}
        firstOptionOnOpen={fromOptions.findIndex((option) =>
          timeSlot.from ? option.value === timeSlot.from : option.value === "9:00"
        )}
      />
      <DropdownField
        title={"To"}
        defaultOption={{ value: null, option: "To" }}
        options={toOptions}
        selectedOption={timeSlot.to}
        onChange={(value) => setToSlot(value)}
        errorMessage={!isValid}
        firstOptionOnOpen={toOptions.findIndex((option) =>
          timeSlot.to ? option.value === timeSlot.to : option.value === "17:00"
        )}
      />
      <div className="flex w-32 gap-4 justify-start items-center">
        {canDelete && (
          <img
            src="/assets/icons/common/trash.svg"
            alt="delete"
            className="size-4 cursor-pointer hover:opacity-80"
            onClick={onDeleteTimeSlot}
          />
        )}
        {canAdd && (
          <img
            src="/assets/icons/common/plus.svg"
            alt="+"
            className="size-3 cursor-pointer hover:opacity-80"
            onClick={onAddNewTimeSlot}
          />
        )}
      </div>
    </div>
  );
};

export default TimeSlot;
